/** @format */
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { StateService } from '@uirouter/core';
import { CeeposPaymentConfirmation, OpenUniversityPaymentSystemLog } from 'common-typescript/types';
import { catchError, retry, throwError } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppErrorHandler, OpenUniversityPaymentSystemService, PaymentSystemLogEntityService } from 'sis-components';
import { CeeposPaymentService } from '../../../common/service/ceepos-payment.service';

@Component({
    selector: 'app-ceepos-payment-complete',
    templateUrl: './ceepos-payment-complete.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CeeposPaymentCompleteComponent implements OnInit {
    constructor(
        private paymentSystemLogEntityService: PaymentSystemLogEntityService,
        private openUniversityPaymentSystemService: OpenUniversityPaymentSystemService,
        private stateService: StateService,
        private appErrorHandler: AppErrorHandler,
        private ceeposPaymentService: CeeposPaymentService,
    ) {}

    ngOnInit(): void {
        const ceeposPaymentConfirmation = this.ceeposPaymentService.readCeeposResponseFromQueryParams();

        this.logCeeposPaymentConfirmation(ceeposPaymentConfirmation);
        this.openUniversityPaymentSystemService
            .completeCeeposPayment(ceeposPaymentConfirmation)
            .pipe(
                take(1),
                retry({ count: 3, delay: 10000 }), // if error, wait 10 seconds and try the request again (max 3 times)
                catchError(err => this.redirectToPaymentProcessingPage(err)),
                this.appErrorHandler.defaultErrorHandler(),
            )
            .subscribe({
                next: payment => {
                    if (payment?.status === 'PAID') {
                        this.stateService.go('student.open-university-cart.payment-successful', { paymentId: payment.id });
                    } else if (payment?.status === 'CANCELLED') {
                        this.stateService.go('student.open-university-cart.payment-failed');
                    } else {
                        this.stateService.go('student.open-university-cart.payment-processing');
                    }
                },
            });
    }

    private logCeeposPaymentConfirmation(ceeposPaymentConfirmation: Partial<CeeposPaymentConfirmation>) {
        const paymentSystemLog: Partial<OpenUniversityPaymentSystemLog> = {
            jsonLog: JSON.stringify(ceeposPaymentConfirmation),
            paymentId: ceeposPaymentConfirmation.Id,
            paymentSystem: 'CEEPOS',
            paymentSystemLogMsgDirection: 'FRONTEND_INBOUND',
        };
        this.paymentSystemLogEntityService.create(paymentSystemLog);
    }

    private redirectToPaymentProcessingPage(err: any) {
        this.stateService.go('student.open-university-cart.payment-processing');
        return throwError(() => err);
    }
}
